import {SettingsAdminAuditLogDataEventObjectsEnum} from './settings/settingsAdminAuditLogDataEventObjects';
import {SettingsAdminCopilotDataEventObjectsEnum} from './settings/settingsAdminCopilotDataEventObjects';
import {SettingsAiDataEventObjectsEnum} from './settings/settingsAiDataEventObjects';
import {SettingsChannelProactiveMessageDataEventObjectsEnum} from './settings/settingsChannelProactiveMessageDataEventObjects';
import {SettingsCirclesDataEventObjectsEnum} from './settings/settingsCirclesDataEventObjects';
import {SettingsCompanyPreferencesDataEventObjectsEnum} from './settings/settingsCompanyPreferencesDataEventObjects';
import {SettingsCustomerPortalDataEventObjectsEnum} from './settings/settingsCustomerPortalDataEventObjects';
import {SettingsDynamicVariablesObjectsEnum} from './settings/settingsDynamicVariablesEventObjects';
import {SettingsFlowchartRulesDataEventObjectsEnum} from './settings/settingsFlowchartRulesDataEventObjects';
import {SettingsP1DataEventObjectsEnum} from './settings/settingsP1DataEventObjects';
import {SettingsPermissionsDataEventObjectsEnum} from './settings/settingsPermissions';
import {SettingsPlaybooksDataEventObjectsEnum} from './settings/settingsPlaybooksDataEventObjects';
import {SettingsRulesDataEventObjectsEnum} from './settings/settingsRulesDataEventObjects';
import {SettingsSharedActionsDataEventObjectsEnum} from './settings/settingsSharedActionsDataEventObjects';
import {SettingsTeammatesDataEventObjectsEnum} from './settings/settingsTeammatesDataEventObjects';
import {SettingsTimeOffDataEventObjectsEnum} from './settings/settingsTimeOffDataEventObjects';
import {SettingsTopicsDataEventObjectsEnum} from './settings/settingsTopicsDataEventObjects';
import {SettingsWorkforceStaffingsDataEventObjectsEnum} from './settings/settingsWorkforceStaffingsDataEventObjects';

export enum CommonSettingsDataEventObjectsEnum {
  PAGE = 'page',
  ANNOTATION = 'annotation',
}

export const SettingsDataEventObjects = {
  ...CommonSettingsDataEventObjectsEnum,
  ...SettingsAiDataEventObjectsEnum,
  ...SettingsCirclesDataEventObjectsEnum,
  ...SettingsCompanyPreferencesDataEventObjectsEnum,
  ...SettingsRulesDataEventObjectsEnum,
  ...SettingsTeammatesDataEventObjectsEnum,
  ...SettingsDynamicVariablesObjectsEnum,
  ...SettingsCustomerPortalDataEventObjectsEnum,
  ...SettingsAdminAuditLogDataEventObjectsEnum,
  ...SettingsChannelProactiveMessageDataEventObjectsEnum,
  ...SettingsSharedActionsDataEventObjectsEnum,
  ...SettingsP1DataEventObjectsEnum,
  ...SettingsWorkforceStaffingsDataEventObjectsEnum,
  ...SettingsTopicsDataEventObjectsEnum,
  ...SettingsTimeOffDataEventObjectsEnum,
  ...SettingsFlowchartRulesDataEventObjectsEnum,
  ...SettingsAdminCopilotDataEventObjectsEnum,
  ...SettingsPermissionsDataEventObjectsEnum,
  ...SettingsPlaybooksDataEventObjectsEnum,
};
